import { Layout } from "react-admin";
import { MyAppBar } from "./MyAppBar";
/* Import TreeMenu from the package */
import TreeMenu from "@bb-tech/ra-treemenu";

export const MyLayout = (props) => <Layout {...props} menu={TreeMenu} appBar={MyAppBar} />;
